import _ from 'lodash';
import React, {Component} from "react";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {withFirebase} from 'react-redux-firebase';
import {Helmet} from "react-helmet";

import {getPoll, resetPollData} from '../../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Hidden from "@material-ui/core/Hidden";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import PollSection from "./PollSection.js";
import MetaSection from "./MetaSection.js";
import TweetSection from "./TweetSection.js";
import DisqusSection from "./DisqusSection.js";
import CommentSection from "./TalkYardComments.js";

class PollTemplate extends Component {
  componentWillMount() {
    console.log('before the mount, reset');
    this.props.resetPollData();
  }

  componentWillUnmount() {
    // reset poll data!!!?
  }

  componentDidMount() {
    const _404Callback = () => this.props.history.push({
      pathname: '/404',
      state: {from: this.props.location.pathname}
    });
    const {pollid} = this.props.match.params;
    if (this.props.homeUrl) {
      this.props.getPoll(this.props.homeUrl, _404Callback);
    } else {
      this.props.getPoll(pollid, _404Callback);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkPollDataUpdate(prevProps);
  }

  checkPollDataUpdate(prvProps){
    let {pollid} = this.props.match.params;
    let prevPollid = prvProps ? prvProps.match.params.pollid : '';
    const {homeUrl} = this.props;

    if (this.props.homeUrl && !pollid) {
      pollid = homeUrl;
    }
    if (this.props.homeUrl && !prevPollid) {
      prevPollid = homeUrl;
    }

    if (prevPollid && pollid) {
      if (pollid !== prevPollid) {
        const {resetPollData, getPoll} = this.props;
        resetPollData();
        const _404Callback = () => this.props.history.push({
          pathname: '/404',
          state: {from: this.props.location.pathname}
        });
        getPoll(pollid, _404Callback);
      }
    } else if (!prevPollid && pollid) {
      const {resetPollData, getPoll} = this.props;
      resetPollData();
      const _404Callback = () => this.props.history.push({
        pathname: '/404',
        state: {from: this.props.location.pathname}
      });
      getPoll(pollid, _404Callback);
    }
  }

  renderMetaTags() {
    const {poll} = this.props;
    const has_poll_data = (!poll.loading && !_.isEmpty(poll.data));
    if (has_poll_data) {
      const {answers, question, img, poll_hash, poll_id, pollmeta} = poll.data;
      const {descrip, keywords, categories} = pollmeta;
      const url = `https://www.pollpals.com/poll/${poll_hash}`;
      const quesNAns = `${question} : ${answers.map(ans => { return ans.answer}).join(', ')}`;
      // QUESTION should title tags only be 70 chars?? I'll assume so for now
      // quesNAns = quesNAns.length < 71 ? quesNAns : `${quesNAns.substring(0,69)} ...`;
      const descripWQA = `${quesNAns}. ${descrip}`;

      const kwords = keywords ? keywords : 'generic, fake, please update';
      const cats = categories ? categories : 'general, fake, pollpals';
      // NOTE QUESTION why do i need to do this??? one url for internal? one for external??
      const shareable_img_temp = img.replace('pollpals-poll-imgs/', '');
      const shareable_img = shareable_img_temp.replace('https://s3', 'https://pollpals-poll-imgs.s3');

      return (
        <Helmet>
          {/* <meta charSet="utf-8" /> */}
          <title>{question}</title>
          <meta name="description" content={descripWQA} />
          {/* <meta name="keywords" content={kwords} /> */}
          {/* QUESTION for OG, should I add type article?? or make own type?? */}
          <meta property="og:title" content={question} />
          <meta property="og:type" content="website" />
          <meta property="og:image" content={shareable_img} />
          <meta property="og:image:url" content={shareable_img} />
          {/* <meta property="og:image:type" content="image/jpeg" /> */}
          <meta property="og:image:width" content="400" />
          <meta property="og:image:height" content="300" />
          <meta property="og:url" content={url} />
          <meta property="og:site_name" content="Poll Pals"/>
          <meta property="og:description" content={descripWQA} />
          {/* note twitter has its own tags, but can understand OG tags */}
          <meta name="twitter:card" content="summary_large_image" />
          {/* twt image tag should NOT be necessary.... but only works with? */}
          <meta name="twitter:image:src" content={shareable_img} />
        </Helmet>
      );
    }
  }

  render() {
    const {classes, poll, history, ...rest} = this.props;

    if (poll.loading || _.isEmpty(poll.data)) {
      return <LoadingSpinner />;
    }

    return (
      <div>
        {this.renderMetaTags()}
        <Header
          color="white"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax filter image={poll.data.img}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Hidden only="xs">
                  <h1 className={classes.title}>{poll.data.question}</h1>
                  <br />
                  <a href="#poll" className={classes.voteButton}>VOTE NOW</a>
                </Hidden>
                <Hidden smUp>
                  <h1 className={classes.xsTitle}>{poll.data.question}</h1>
                </Hidden>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <PollSection addThisLoaded={this.props.addThisLoaded} />
          <MetaSection />
          <Hidden xsDown><TweetSection/></Hidden>
          <DisqusSection />
          {/* <CommentSection data-discussion-id={poll.data.poll_hash}/> */}
        </div>
        <Footer />
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withStyles(landingPageStyle)(withFirebase(PollTemplate));

function mapStateToProps(state) {
  return {
    poll: state.poll,
  };
}

export default withRouter(connect(mapStateToProps, {getPoll, resetPollData})(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/PollTemplate.js